// extracted by mini-css-extract-plugin
module.exports =  {"menu":"SideMenu-module__menu___j2P0P","active":"SideMenu-module__active___aJoH3"};